import { useStepDetectiveContext } from '../../../../../../../../components/csv-import/ui/components/step-detective/step-detective-context';
import { MappingImportStepFooter } from '../mapping-import-step';

export const MappingStepFooter = () => {
  const { goToPrevious } = useStepDetectiveContext();
  return <MappingImportStepFooter onPrevClick={goToPrevious} />;
};
